module.exports = __webpack_public_path__ + "img/card-evaluation-tracking-report.4f8f2f76.svg";